import { render, staticRenderFns } from "./SundryItemsTabView.vue?vue&type=template&id=b04c697e&"
import script from "./SundryItemsTabView.vue?vue&type=script&lang=js&"
export * from "./SundryItemsTabView.vue?vue&type=script&lang=js&"
import style0 from "./SundryItemsTabView.vue?vue&type=style&index=0&id=b04c697e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports